module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vheader'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "about-title"
  }, [_vm._v("简介")]), _vm._v(" "), _c('div', {
    staticClass: "about-detail"
  }, [_vm._v("本项目是基于Cnodejs的api，采用vuejs前端框架，借助webpack开发的单页面web应用")]), _vm._v(" "), _c('div', {
    staticClass: "about-title"
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "about-detail"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/luckybirdme/Vuejs-cnodejs"
    }
  }, [_vm._v("https://github.com/luckybirdme/Vuejs-cnodejs")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-774b98f8"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/About.vue
// module id = 156
// module chunks = 1